var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "invoice-tabs-parent" }, [
    _c("div", { staticClass: "invoice-tabs-header mb-5 font-outfit" }, [
      _c(
        "ul",
        { staticClass: "invoice-tabs flex gap-6" },
        _vm._l(_vm.tabs, function (tab, index) {
          return _c(
            "li",
            {
              key: tab.name,
              class: {
                "px-1.5 py-2 cursor-pointer text-gray-400 text-lg flex items-center": true,
                "invoice-active": _vm.activeTab === index,
              },
              on: {
                click: function ($event) {
                  return _vm.setActiveTab(index)
                },
              },
            },
            [
              _vm._v(" " + _vm._s(tab.name) + " "),
              tab.badge
                ? _c(
                    "span",
                    {
                      staticClass:
                        "invoice-badge badge w-6 h-6 rounded-full bg-gray-200 text-gray-500 text-center flex items-center justify-center ml-1",
                    },
                    [_vm._v(_vm._s(tab.badge))]
                  )
                : _vm._e(),
            ]
          )
        }),
        0
      ),
    ]),
    _c(
      "div",
      { staticClass: "tab-content" },
      [_vm._t("tab-" + _vm.activeTab)],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }